import script from "./DanhSachNganhNghe.vue?vue&type=script&setup=true&lang=js"
export * from "./DanhSachNganhNghe.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__